import { ActionIcon, createStyles, Text } from '@mantine/core';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Icon123, IconAbc, IconListDetails,IconEdit } from '@tabler/icons-react';

const useStyles = createStyles((theme) => ({
    item: {
        display: 'flex',
        alignItems: 'center',
        borderRadius: theme.radius.md,
        border: `1px solid  ${theme.colors.gray[3]}`,
        padding: `0px 0px`,
        backgroundColor: theme.white,
        padding: '10px 0px',
        marginBottom: theme.spacing.xs,
        width: '100%'
    },

    itemDragging: {
        boxShadow: theme.shadows.sm,
    },

    symbol: {
        fontSize: '20px',
        fontWeight: 500,
        color: theme.colors.gray[6],
        ...theme.fn.focusStyles(),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '50px',
    },

    questionWrapper:{
        flexGrow: 1,
        width: '10px',

    },

    questionText: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },

    dragHandle: {
        ...theme.fn.focusStyles(),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        color: theme.colors.gray[6],
        paddingLeft: theme.spacing.sm,
    },

    editIcon: {
        marginRight: theme.spacing.xs,
        color: theme.colors.gray[6],
        height: '100%',
    },
}));

const getIcon = (questionType) => {
    switch (questionType) {
        case 'Multiple choice':
            return <IconListDetails stroke={1.5} size = {20}/>
        case 'Number entry':
            return <Icon123 stroke={1.5} size = {20}/>
        case 'Open ended':
            return <IconAbc stroke={1.5} size = {20}/>
        default:
            return  <IconListDetails stroke={1.5} size = {20}/>
    }
}

const reOrderList = (arr, startIdx, endIdx) => {
    if (startIdx < 0 || startIdx >= arr.length || endIdx < 0 || endIdx >= arr.length) {
      throw new Error("Invalid index values");
    }
  
    const temp = arr[startIdx];
    arr[startIdx] = arr[endIdx];
    arr[endIdx] = temp;
  
    return arr;
}

const DragNDrop = ({form, setModalData, setConditionModalOpen}) => {
    
    const { classes, cx } = useStyles();

    if (form.values.customQuestionsAndResponses.length === 0) return <></>;

    const items = form.values.customQuestionsAndResponses.map((item, index) => (
        <Draggable key={item.question} index={index} draggableId={item.question}>
            {(provided, snapshot) => (
                <div
                    className={cx(classes.item, { [classes.itemDragging]: snapshot.isDragging })}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={provided.innerRef}
                >
                    <div className={classes.symbol}>{getIcon(item.questionType)}</div>
                    <div className = {classes.questionWrapper}>
                        <Text size='sm' className={classes.questionText}>{item.question}</Text>
                        <Text color="dimmed" size="sm">
                            Response: { item.questionType === 'Multiple choice' ? item.options[item.chosenOptionIndex] : item.response }
                        </Text>
                    </div>
                    <div>
                    <ActionIcon 
                        className={classes.editIcon}
                        onClick = {() => {
                            setModalData(item);
                            setConditionModalOpen(true);
                        }}
                    >
                        <IconEdit stroke={1.5} size={20} />
                    </ActionIcon>
                    </div>
                </div>
            )}
        </Draggable>
    ));

    return (
        <DragDropContext
            onDragEnd={({ destination, source }) => {   
                const newList = reOrderList([...form.values.customQuestionsAndResponses], source.index, destination.index);
                form.setFieldValue('customQuestionsAndResponses', newList);
            }}
        >
            <Droppable droppableId="dnd-list" direction="vertical">
                {(provided) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                        {items}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
}

export default DragNDrop;